import { createSlice } from "@reduxjs/toolkit";

const alertsSlice = createSlice({
  name: "alerts",
  initialState: {
    alerts: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    alertsStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    alertsSuccess: (state, action) => {
      state.alerts = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    alertsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    deleteStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteSuccess: (state, action) => {
      state.alerts = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    deleteFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    logoutInfoAlerts: (state) => {
      state.alerts = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  alertsStart,
  alertsSuccess,
  alertsFailure,
  deleteStart,
  deleteSuccess,
  deleteFailure,
  logoutInfoAlerts
} = alertsSlice.actions;
export default alertsSlice.reducer;
